import { DuplicateId } from "@mcleod/dispatch/src/DuplicateId";
import { AutogenLayoutTieredStopPay } from "./autogen/AutogenLayoutTieredStopPay";
import { TableRowMoveEvent, DataSourceExecutionEvent, DataSourceMode, BlurEvent, Snackbar, Textbox, TableRowDisplayEvent, TableRowCreationEvent } from "@mcleod/components";

export class TieredStopPay extends AutogenLayoutTieredStopPay {
    private DUPLICATE_VALIDATION_PROPS = {
        tableName: "tiered_stop",
        screenName: "Tiered Stop Pay",
        navigateToUrl: "lme/settlement/TieredStopPay?mode=update&key="
    }

    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, this.DUPLICATE_VALIDATION_PROPS);
        this.mainDataSource.doBeforeDataSourcePost = async () => {
            if (!(await DuplicateId.validateBeforePost(this.textboxId, this.DUPLICATE_VALIDATION_PROPS))) {
                return false;
            }
            if (this.sourceTieredStopPayRates.data.length === 0) {
                Snackbar.showWarningSnackbar("A tiered stop rate must be entered before record can be saved.", {
                    millisUntilDismissal: 8000,
                    targetPanel: this
                });
                return false;
            }
            return true;
        }

    }


    private setRateRanges() {
        // Not sure if this is needed. Is "rows" always in the order of what is in the table?
        const rows = this.tableTieredStopPayRates.rows.sort((a, b) =>
            (a.data.get("sequence") || 0) - (b.data.get("sequence") || 0)
        );

        let currentStart = 1;
        rows.forEach((row, index) => {
            const textboxRange = row.findComponentById("textboxStopRange") as Textbox;
            if (!textboxRange) return;

            const numberOfStops = row.data.get("number_of_stops");
            const isLastRow = index === rows.length - 1;

            if (isLastRow) {
                textboxRange.text = `${currentStart} and above`;
            } else {
                const currentEnd = currentStart + numberOfStops - 1;
                textboxRange.text = `${currentStart}-${currentEnd}`;
                currentStart = currentEnd + 1;
            }
        });
    }

    /** This is an event handler for the afterTableRowMove event of tableTieredStopPayRates. */
    tableTieredStopPayRatesAfterTableRowMove(event: TableRowMoveEvent) {
        this.setRateRanges();
    }



    /** This is an event handler for the onRowCreate event of tableTieredStopPayRates. */
    tableTieredStopPayRatesOnRowCreate(event: TableRowCreationEvent) {
        if (this.mainDataSource.mode !== DataSourceMode.SEARCH) {
            this.setRateRanges();
        }
    }

    /** This is an event handler for the afterExecution event of sourceTieredStopPayRates. */
    sourceTieredStopPayRatesAfterExecution(event: DataSourceExecutionEvent) {
        if (event.dataSource.mode === DataSourceMode.SEARCH) {
            this.setRateRanges();
        }
    }

    /** This is an event handler for the onBlur event of textboxNumberOfStops. */
    textboxNumberOfStopsOnBlur(event: BlurEvent) {
        if (this.mainDataSource.mode !== DataSourceMode.SEARCH) {
            this.setRateRanges();
        }
    }

    /** This is an event handler for the onRowDisplay event of tableTieredStopPayRates. */
    tableTieredStopPayRatesOnRowDisplay(event: TableRowDisplayEvent) {
        if (this.mainDataSource.mode !== DataSourceMode.SEARCH) {
            this.setRateRanges();
        }
    }
}
